<template>
  <div class="MajorSearchBackground" id="MajorSearchBackground" :style="{height:screenHeight}">
    <div id="header">
      <div id="headerBtnContainer">
        <div class="headerLineOne">

          <div>
            <el-button type="primary"  @click="goFirstPage">院校查询</el-button>
            <el-button class="deepBlueBtn" type="primary"  @click="goProfessionSearch">职业查询</el-button>

          </div>
        </div>
        <div class="headerLineTwo">
          <div id="selectSearchContainer">
            <el-select style="width: 100px" v-model="level"
                       @change="selectChange" placeholder="选择专业层次" popper-class="elPopperSelect">
              <el-option :value="1" label="普本"/>
              <el-option :value="2" label="职本"/>
              <el-option :value="3" label="专科"/>
            </el-select>
          </div>

          <div id="inputSearchContainer">
            <el-input style="width: 150px" :prefix-icon="Search" clearable
                      @clear="inputSearchButtonClick" v-model="majorName" placeholder="输入专业名称"
                      @keyup.enter="inputSearchButtonClick"/>
            <el-button id="inputSearchButton"  @click="inputSearchButtonClick">搜索
            </el-button>
          </div>
        </div>
      </div>

      <div id="menuContainer">包含专业</div>
      <div id="headerTips">注：国标代码不可用于填报</div>

    </div>
    <div id="mainBody" ref="mainBodyScrollBar" v-infinite-scroll="getCollegeInfoArray"
         :infinite-scroll-immediate="false">
      <div id="IncludingColleges">
        <div class="collegesContainer" v-for="item in mainArray.slice(0,overNum)">
          <div class="collegesLine1">
            <span @click="goMajorSituation(item.majorCode)">{{item.majors}}</span>
          </div>
          <div class="collegesLine2">
            <el-row class="collegesLine2Item">
              <el-col :span="24">学科门类：{{item.categories}}</el-col>
            </el-row>
            <el-row class="collegesLine2Item">
              <el-col :span="24">专业大类：{{item.majorGroup}}</el-col>
            </el-row>
            <el-row class="collegesLine2Item">
              <el-col :span="24">国标代码：{{item.majorCode}}</el-col>
            </el-row>
          </div>
        </div>
        <el-empty style="margin-top: 100px" v-if="mainArray.length == 0" description="暂无数据"/>
      </div>
    </div>
  </div>
</template>

<script setup>
  import {ref, reactive, nextTick, onMounted, onDeactivated, onActivated} from 'vue'
  import {ElMessage} from 'element-plus';
  import {Search} from '@element-plus/icons-vue'
  import {useRouter, useRoute} from "vue-router";
  import {majorsFindMajorByName} from "@/network/axios";

  let router = useRouter();
  let route = useRoute();

  //固定手机端的屏幕高度，（出键盘会把屏幕挤扁）
  let screenHeight = ref('');
  onMounted(() => {
    let MajorSearchBackground = document.getElementById('MajorSearchBackground');
    let height = MajorSearchBackground.offsetHeight;
    screenHeight.value = height + 'px';
  });


  let goFirstPage = () => {
    router.push('/MobileFirstPage')
  }

  let goProfessionSearch = () => {
    router.push('/MobileProfessionSearch')
  };


  let mainArray = ref([]);
  let level = ref(1);
  let majorName = ref('');

  //获取 mainBody的dom元素
  let mainBodyScrollBar = ref()

  let searchMajor = () => {
    majorsFindMajorByName('/majors/findMajorByName', {
      params: {
        leave: level.value,
        majorName: majorName.value,
      }
    }).then((res) => {
      if (res.data.code == 200) {
        overNum.value = 30;
        nextTick(() => {
          mainBodyScrollBar.value.scrollTop = 0;
        });
        mainArray.value = [];
        mainArray.value = res.data.data;
      }
    })
  }
  searchMajor();

  //无限滚动
  let overNum = ref(30);
  let getCollegeInfoArray = () => {
    if (overNum.value < mainArray.value.length) {
      overNum.value += 15
    }
  }


  let selectChange = () => {
    searchMajor()
  };

  let inputSearchButtonClick = () => {
    searchMajor()
  };

  let goMajorSituation = (majorCode) => {
    router.push('/MobileMajorSituation' + '/' + majorCode)
  }


  //离开页面时，记录滚动条，返回页面时 滚动条 再回到之前的位置
  let backScrollBar = ref()
  //缓存组件 离开页面前
  onDeactivated(() => {
    backScrollBar.value = mainBodyScrollBar.value.scrollTop;
  });
  //缓存组件 被激活时
  onActivated(() => {
    mainBodyScrollBar.value.scrollTop = backScrollBar.value
  });



</script>

<style scoped>
  .MajorSearchBackground {
    position: relative;
    width: 100%;
    height: 100%;
    /*background: #bfa;*/
    /*display: flex;*/
    /*justify-content: left;*/
    /*flex-direction: column;*/
    /*align-items: center;*/
    /*overflow: auto;*/
  }

  #header {
    width: 100%;
    height: 140px;
    /*background: #bfa;*/
    position: relative;
    border: 2px solid #ededed;
    border-bottom: 1px solid #cd3532;
    border-top: none;
    /*display: flex;*/
    /*align-items: center;*/
    /*flex-direction: column;*/
    /*justify-content: space-around;*/
    padding: 0 18px;
  }

  #headerBtnContainer {
    width: 100%;
    height: calc(100% - 23px);
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    /*background: #bfa;*/
  }

  .headerLineOne {
    display: flex;
    align-items: center;
    justify-content:  flex-end;
  }

  .headerLineTwo {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px
  }

  /*头部左半部分搜索的 大容器*/
  #inputSearchContainer {
    display: flex;
    /*justify-content: space-between;*/
    /*width: 100%;*/
    /*align-items: center;*/
  }

  #inputSearchContainer div {
    display: flex;
  }

  /*输入框 字体大于等于16px，不然ios获取焦点后会自动放大*/
  #inputSearchContainer >>> .el-input__inner {
    font-size: 16px;
  }


  #inputSearchButton {
    /*margin-left: 15px;*/
    width: 70px;
    letter-spacing: 7px;
    text-indent: 7px;
    color: white;
    border: none;
  }

  >>> #inputSearchButton {
    --el-button-bg-color: #ce3432;
    --el-button-hover-bg-color: #F56C6C;
  }

  #inputSearchContainer >>> .el-input {
    --el-input-focus-border-color: #F56C6C;
  }

  /*职业查询按钮深蓝样式*/
  >>>.deepBlueBtn{
    --el-button-bg-color: #266FFF;
    --el-button-border-color:#266FFF;
  }

  /*头部右半部分搜索 的大容器*/
  #selectSearchContainer {
    /*display: flex;*/
    /*width: 350px;*/
    /*margin-bottom: 25px;*/
    /*width: 100%;*/
    /*align-items: center;*/
    /*justify-content: space-between;*/
    /*margin-right: 15px;*/
  }


  .selectContainer {
    margin-right: 15px;
  }

  .elPopperSelect .el-select-dropdown__item.selected {
    color: #F56C6C;
  }


  #selectSearchContainer >>> .el-select {
    --el-select-input-focus-border-color: #F56C6C;
  }

  /*ios手机下拉框的字体大小必须大于等于16px，不然点击后会自动放大*/
  #selectSearchContainer >>> .el-input__inner {
    font-size: 16px;
  }


  .elPopperSelect >>> .el-select-dropdown__item.selected {
    color: #F56C6C;
  }

  /* 院校查询 标题栏 */
  #menuContainer {
    position: absolute;
    left: 18px;
    bottom: 0;
    padding: 3px 25px 3px 7px;
    background: #cd3532;
    color: white;
    font-size: 16px;
    border-radius: 4px 4px 0 0;
    cursor: pointer;
    clip-path: polygon(0% 0%, 80% 0%, 100% 100%, 0% 100%);
  }

  /*提示*/
  #headerTips {
    position: absolute;
    left: 140px;
    bottom: 5px;
    color: #606266;
    font-size: 15px;
  }


  /*body 栏*/
  #mainBody {
    width: 100%;
    height: calc(100% - 140px);
    border: 2px solid #ededed;
    border-top: none;
    overflow: auto;
    /*background: #bfa;*/
  }


  #IncludingColleges {
    width: 100%;
    /*height: 100%;*/
    /*background: #bfa;*/
    padding: 0 18px;
    /*border-right: 2px solid #ededed;*/
  }

  .collegesContainer {
    width: 100%;
    height: 110px;
    border-bottom: 1px solid #d4d8e1;
    padding: 5px 0;
    /*background: yellow;*/
  }

  .collegesLine1 {
    width: 100%;
    height: 30%;
    /*background: #bfa;*/
    display: flex;
    align-items: center;
  }

  .collegesLine1 span {
    cursor: pointer;
  }

  .collegesLine1 span:hover {
    color: #F56C6C;
  }

  .collegesLine2 {
    width: 100%;
    height: 70%;
    /*background: orange;*/
    /*display: flex;*/
    /*align-items: center;*/
    font-size: 14px;
    color: #606266;
  }

  .collegesLine2Item {
    height: 33.33%;
    display: flex;
    align-items: center;
  }

  /*@media screen and (max-width:1024px){ 这是各个设备的基本媒体查询。在这个媒体查询中，CSS代码覆盖了横向视图和纵向视图}
 @media screen and (min-width:768px) and (max-width:1024px) and (orientation:landscape){ 平板 }
 orientation: portrait（竖屏，即设备中的页面可见区域高度>=宽度）
 　 orientation: landscape（横屏，即设备中的页面可见区域高度<=宽度）*/
  /*平板 竖屏*/
  @media screen and (min-width: 767px) and (max-width: 1024px) and (orientation: portrait) {

  }

  /*平板 横屏*/
  @media screen and (min-width: 1024px) and (max-width: 1190px) and (orientation: landscape) {
    #MajorSearchBackground {
      width: 767px;
      margin: 0 auto;
    }
  }



</style>
